import { persist, createLocalStorage, createSessionStorage, createIndexedDBStorage } from "@macfja/svelte-persistent-store";
import { writable } from 'svelte/store';

export const displayLang = writable('EN');

export const csrfToken = persist(writable(''), createLocalStorage(), 'csrfToken');
export const unlockCode = persist(writable(''), createLocalStorage(), 'unlockCode');
export const deviceRef = persist(writable(''), createLocalStorage(), 'deviceRef');
export const deviceName = persist(writable(''), createLocalStorage(), 'deviceName');

export const event = persist(writable(null), createLocalStorage(), 'event');
export const settings = persist(writable(null), createLocalStorage(), 'settings');
export const attendee = persist(writable(null), createLocalStorage(), 'attendee');

export const agenda = persist(writable(null), createIndexedDBStorage(), 'agenda');

export const remSize = persist(writable('16px'), createLocalStorage(), 'remSize');

export const refusedInstall = persist(writable(false), createLocalStorage(), 'refusedInstall');
export const androidInstallPrompt = writable(undefined);

export const busy = writable(false);
export const bigError = writable(undefined);
export const success = writable(false);
export const modal = writable(undefined);
export const epoch = writable(0);
export const epochInterval = writable(undefined);

export const offline = writable(false);
export const offlineErrorShown = writable(0);

export const appElement = writable(undefined);

export const showSettings = writable(false);

export const isNarrowScreen = writable(false);

export const syncClient = writable(null);
export const syncChannels = writable({});

export const attendeeLikes = writable([]);
export const shadowbans = writable([]);

export const session = writable(null);
export const spotlight = writable(null);

export const revealMasthead = writable(false);

export const overlays = writable(0);

export const helpTooltip = writable(null);

// export const roomSyncChannel = writable(null);

export const qr = writable(undefined);

